<template>
    <div>
        <card-recharge
            v-if="isAmountLoaded"
            v-show="!paymentStatus"
            :email="email"
            :amount="null"
            :period="period"
            :monthly-cost="monthlyCost"
            :emergency-credit="isEmergencyCredit"
            :is-checkout="true"
            v-on:recharged="onRecharged"
            v-on:paid="onPaymentSuccess"
            v-on:cancelled="onPaymentFailed"
        />

        <div v-if="paymentStatus">
            <div v-if="paymentStatus == 'checking'" class="card card-borderless card-payment-status">
                <div class="card-header bg-white">
                    <i class="fas fa-circle-notch fa-spin text-success"></i>
                    <h3 class="font-title">Estamos quase lá!</h3>
                    <p class="text-muted mb-0">
                        Aguarde um momento enquanto confirmamos o seu pagamento.<br>
                        <small class="font-italic">Esta verificação pode levar até 5 minutos.</small>
                    </p>
                </div>
            </div>

            <div v-if="paymentStatus == 'success'" class="card card-borderless card-payment-status">
                <div class="card-header bg-success text-white">
                    <i class="far fa-check-circle"></i>
                    <h3 class="font-title">Pagamento efetuado com sucesso!</h3>
                </div>
                <div class="card-body">
                    <p class="h5 font-weight-bold mb-6">
                        Escolha como deseja começar sua jornada com a gente:
                    </p>
                    <div class="row">
                        <div class="col-sm-6">
                            <card-link
                                layout="horizontal"
                                text="Criar nova hospedagem"
                                description="A solução ideal para quem vai criar um site do zero ou deseja começar uma hospedagem nova."
                                link="/hosting/create"
                                icon-class="fas fa-server"
                                class="mb-sm-0"
                            />
                        </div>
                        <div class="col-sm-6">
                            <card-link
                                layout="horizontal"
                                text="Migrar meu site gratuitamente"
                                description="Transfira seu site com segurança e agilidade - nossa equipe cuida de tudo, sem perda de dados."
                                link="/hosting/migration"
                                icon-class="fas fa-exchange-alt"
                                class="mb-0"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="paymentStatus == 'failed'" class="card card-borderless card-payment-status">
                <div class="card-header bg-danger text-white">
                    <i class="far fa-times-circle"></i>
                    <h3 class="font-title">Pagamento não confirmado</h3>
                </div>
                <div class="card-body">
                    <p class="h5 font-weight-bold mb-6">
                        Infelizmente, não conseguimos realizar a cobrança.
                    </p>
                    <p>
                        Isso pode ter acontecido por vários motivos. Se o problema persistir, recomendamos verificar:
                    </p>
                    <ul>
                        <li>Seu cartão está desbloqueado;</li>
                        <li>Há limite disponível;</li>
                        <li>Os dados de pagamento informados estão todos corretos;</li>
                        <li>Ou, se preferir, tente usar outro método de pagamento.</li>
                    </ul>
                    <p>
                        Clique no botão abaixo para tentar novamente.
                    </p>
                    <button type="button" class="btn btn-lg btn-block btn-success" @click="resetPayment">
                        Tentar realizar o pagamento novamente
                    </button>
                </div>
            </div>

            <div v-if="paymentStatus == 'completed'" class="card card-borderless card-payment-status">
                <div class="card-header bg-primary text-white">
                    <i class="far fa-clock"></i>
                    <h3 class="font-title">Estamos preparando sua hospedagem</h3>
                </div>
                <div class="card-body">
                    <p class="h5 font-weight-bold mb-6">
                        Recebemos sua solicitação e já começamos a configurar sua nova hospedagem.
                    </p>
                    <p>
                        Você não precisa se preocupar com nada — nossa equipe está cuidando de tudo para que fique pronto o
                        quanto antes.
                    </p>
                    <p>
                        Sua nova hospedagem estará disponível em breve no painel da Hostoo, e entraremos em contato para te
                        orientar com os próximos passos. Fique atento ao seu e-mail ou se desejar entre em contato com nossa
                        equipe de suporte via chat.
                    </p>
                    <a href="/" class="btn btn-lg btn-block btn-success">Acessar painel da Hostoo</a>
                </div>
            </div>
        </div>

        <div class="text-center text-muted small py-4">
            &copy; 2025 Hostoo. Todos os direitos reservados.<br>
            HC4W &bullet; Soluções em Tecnologia e Hospedagem Ltda &bullet; CNPJ 26.316.820/0001-80
        </div>

    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import AjaxService from '@/services/AjaxService'
    import CardTitle from "@/components/molecules/CardTitle.vue";
    import CardLink from "@/components/molecules/CardLink.vue";
    import CardRecharge from '@/components/organisms/CardRecharge'
    import PaymentTemplate from '@/components/templates/PaymentTemplate'

    export default {
        components: {
            CardLink,
            CardTitle,
            CardRecharge,
            PaymentTemplate
        },
        data() {
            return {
                email: "",
                period: 12,
                monthlyCost: 99.9,
                activeServices: 1,
                isAmountLoaded: true,
                isEmergencyCredit: false,
                isRechargeCompleted: false,
                paymentStatus: "",
            }
        },
        computed: {

        },
        beforeRouteEnter(to, from, next)
        {
            if (to.query.email) {
                next(vm => {
                    vm.email = to.query.email;
                    vm.period = to.query.annual == "1" ? 12 : 1;
                });
            }
            else {
                next('/auth/login');
            }
        },
        beforeRouteLeave(to, from, next)
        {
            if (!this.isRechargeCompleted) {
                if (!confirm('A recarga não foi concluída. Se deixar esta página agora, o pedido poderá ser cancelado. Tem certeza que deseja continuar?')) return;
            }

            AjaxService.cancel();
            next();
        },
        mounted()
        {
            // Unload event
            window.addEventListener('unload', this.onPageUnload);

            // Tag de conversão do Facebook
            if (typeof window.fbq !== "undefined") {
                fbq('track', 'InitiateCheckout');
            }

            // Tag de conversão do Google Ads
            if (typeof window.gtag !== 'undefined') {
                gtag('event', 'conversion', {'send_to': 'AW-798302531/Gf8WCLnakcQBEMPC1PwC'});
            }
        },
        beforeDestroy()
        {
            window.removeEventListener('unload', this.onPageUnload);
        },
        methods: {
            ...mapActions({
                showLoading: 'loading/show',
                hideLoading: 'loading/hide',
                showErrorAlert: 'alert/error',
            }),

            resetPayment()
            {
                this.isRechargeCompleted = true;
                setTimeout(() => { window.location.reload() }, 1000);
            },

            onRecharged()
            {
                this.paymentStatus = "checking";
            },

            onPaymentSuccess()
            {
                this.paymentStatus = "success";
                this.isRechargeCompleted = true;
            },

            onPaymentFailed()
            {
                this.paymentStatus = "failed";
            },

            /**
             * Prevent from leaving page.
             * @param {Event} evt
             */
            onPageUnload(evt)
            {
                if (!this.isRechargeCompleted) {
                    if (!confirm('A recarga não foi concluída. Se deixar esta página agora, o pedido poderá ser cancelado. Tem certeza que deseja continuar?')) {
                        evt.preventDefault();
                        evt.returnValue = false;
                    }
                }
            }
        }
    }
</script>

<style lang="stylus">
    .card-payment-status {
        box-shadow 0 4px 10px rgba(0,0,0,0.15)

        @media (min-width 576px) {
            border-radius 5px
            margin-bottom 2rem
        }

        > .card-header {
            padding-top 50px
            padding-bottom 50px
            text-align center

            @media (min-width 992px) {
                font-size 1.125rem
            }

            i {
                font-size: 3rem
            }

            h3 {
                margin-top .5rem
                font-weight 400

                &:last-child {
                    margin-bottom 0
                }

                @media (min-width 992px) {
                    font-size 2em
                }
            }
        }

        > .card-body {
            @media (min-width 992px) {
                padding 2rem
            }
        }

        .h-m-card-link {
            border 2px solid $gray-300
            border-radius 5px
            box-shadow none
        }
    }
</style>
